import * as RadixSlider from '@radix-ui/react-slider';
import React from 'react';

/**
 * Reusable Slider component using Radix UI
 * Props:
 * - min: minimum value
 * - max: maximum value
 * - step: step size
 * - value: [min, max] array
 * - onValueChange: function([min, max]) - called during drag
 * - onValueCommit: function([min, max]) - called when drag ends
 * - className: optional string for root
 */
export default function Slider({
  min,
  max,
  step = 1,
  value,
  onValueChange,
  onValueCommit,
  className = '',
  ...props
}) {
  return (
    <RadixSlider.Root
      className={`relative flex h-6 w-full touch-none select-none items-center ${className}`}
      min={min}
      max={max}
      step={step}
      value={value}
      minStepsBetweenThumbs={0}
      onValueChange={onValueChange}
      onValueCommit={onValueCommit}
      {...props}
    >
      <RadixSlider.Track className="relative h-2 grow rounded-full bg-clr-disabled">
        <RadixSlider.Range className="absolute h-full rounded-full bg-clr-on-bg-high" />
      </RadixSlider.Track>
      <RadixSlider.Thumb
          className="block size-6 rounded-[20px] bg-clr-bg-main border border-clr-on-bg-high pointer-coarse:p-7"
          aria-label="Volume"
      />
      <RadixSlider.Thumb
          className="block size-6 rounded-[20px] bg-clr-bg-main border border-clr-on-bg-high pointer-coarse:p-7"
          aria-label="Volume2"
      />
    </RadixSlider.Root>
  );
}
